// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__3SU5U","inner":"Footer_inner__2o40V","nextIcon":"Footer_nextIcon__1werb","innerLeft":"Footer_innerLeft__3GRXG"};